import React from "react";
import { FaArrowRight } from "react-icons/fa6";
import { SiSwift, SiKotlin, SiFlutter, SiReact, SiFirebase, SiNodedotjs } from "react-icons/si";
import { Container } from "../home/ui";
import { Eyebrow, H2 } from "./mobileUi";

const tech = [
  { icon: SiSwift, label: "Swift", cls: "text-[#F05138]" },
  { icon: SiKotlin, label: "Kotlin", cls: "text-[#7F52FF]" },
  { icon: SiFlutter, label: "Flutter", cls: "text-[#42A5F5]" },
  { icon: SiReact, label: "React Native", cls: "text-[#22B8E8]" },
  { icon: SiFirebase, label: "Firebase", cls: "text-[#FFA000]" },
  { icon: SiNodedotjs, label: "Node.js", cls: "text-[#539E43]" },
];

// Real mobile apps from the portfolio page (src/Pages/ProjectScreen.js).
const apps = [
  {
    name: "HealthOMax App",
    text: "Network for medical professionals",
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/healthomaxappimg-C.png",
    href: "/our-completed-projects/healthomax-mobile-app",
  },
  {
    name: "SmartCare Patient App",
    text: "Book and manage doctor visits",
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/patientappimg-B.png",
    href: "/our-completed-projects/smartcare-mobile-app-for-ios-andriod",
  },
  {
    name: "SmartCare Doctor App",
    text: "Clinic management on the go",
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/docappimg-A.png",
    href: "/our-completed-projects/clinic-management-mobile-app",
  },
];

const MobileTechWork = () => (
  <>
    {/* Technologies */}
    <section className="bg-[#F5F7FD] py-[40px] lg:py-[48px]">
      <Container className="max-w-[1320px]">
        <div className="grid items-center gap-[28px] lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)] lg:gap-[40px]">
          <div>
            <Eyebrow>Technologies We Use</Eyebrow>
            <H2 className="mt-[14px]">Modern Tech for Powerful Apps</H2>
            <p className="mt-[12px] max-w-[460px] text-[15px] leading-[1.65] text-slate-600">
              We use the latest technologies and tools to build secure, scalable and high-performance mobile applications.
            </p>
          </div>
          <div className="grid grid-cols-3 gap-[14px] sm:grid-cols-6">
            {tech.map((t) => (
              <div
                key={t.label}
                className="flex aspect-[1/1.1] flex-col items-center justify-center gap-[12px] rounded-[14px] bg-white px-[6px] shadow-[0_10px_26px_-20px_rgba(15,27,76,0.35)] transition hover:-translate-y-1"
              >
                <t.icon className={`text-[38px] ${t.cls}`} />
                <span className="text-center text-[13px] font-medium text-[#0F1B4C]">{t.label}</span>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>

    {/* Featured work */}
    <section className="bg-white py-[44px] lg:py-[56px]">
      <Container className="max-w-[1320px]">
        <div className="grid items-center gap-[28px] lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)] lg:gap-[40px]">
          <div>
            <Eyebrow line={false}>Featured Work</Eyebrow>
            <H2 className="mt-[14px]">Mobile Apps We&apos;ve Built</H2>
            <p className="mt-[12px] max-w-[420px] text-[15px] leading-[1.65] text-slate-600">
              Explore some of our successful mobile app projects that have helped businesses grow and create meaningful
              user experiences.
            </p>
            <a
              href="/our-completed-projects"
              className="group mt-[22px] inline-flex items-center gap-[8px] text-[15px] font-medium text-[#3D5AFE]"
            >
              View All Projects
              <FaArrowRight className="text-[13px] transition group-hover:translate-x-1" />
            </a>
          </div>
          <div className="m-swipe grid gap-[20px] sm:grid-cols-3">
            {apps.map((a) => (
              <a key={a.name} href={a.href} className="group">
                <div className="aspect-[4/2.6] overflow-hidden rounded-[10px] bg-gradient-to-br from-[#E4EEFF] to-[#EEF0FF]">
                  <img
                    src={a.img}
                    alt={`${a.name} screens`}
                    loading="lazy"
                    className="h-full w-full object-contain transition duration-500 group-hover:scale-105"
                  />
                </div>
                <p className="mt-[12px] text-[15px] font-semibold text-[#0F1B4C]">{a.name}</p>
                <p className="mt-[2px] text-[13px] text-slate-500">{a.text}</p>
              </a>
            ))}
          </div>
        </div>
      </Container>
    </section>
  </>
);

export default MobileTechWork;
